import { MenuItem, TextField, useMediaQuery } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { useRef } from "react";
import dayjs from "dayjs";

export const MuiTable = ({
  data,
  isLoading,
  columns,
  actionText,
  onChangeAction,
  setSelectedData,
  enableColor,
  enableRowSelection,
  enableActionButton,
  onRowClick, // ✅ Accept onRowClick prop
}) => {
  const tableRef = useRef(null);
  const isMobileScreen = useMediaQuery("(max-width:768px)");

  // Function to determine the row background color based on leadStatus
  const getRowBackgroundColor = (leadStatus) => {
    if (!enableColor) return undefined;
    // You can define your custom color logic here
    // return color based on leadStatus
    return undefined;
  };

  return (
    <MaterialReactTable
      state={{ isLoading: isLoading }}
      tableInstanceRef={tableRef}
      enableStickyHeader={!isMobileScreen}
      muiTableContainerProps={{
        sx: { maxHeight: isMobileScreen ? "100%" : "calc(100vh - 300px)" },
      }}
      columns={columns}
      data={data ?? []}
      enableRowSelection={enableRowSelection}
      enableDensityToggle={false}
      initialState={{ density: "compact", pagination: { pageSize: 10 } }}
      enableMultiRowSelection={false}
      getRowId={(row) => row.leadid}
      onRowSelect={(row) => {
        if (enableRowSelection) {
          setSelectedData((prevSelected) => [...prevSelected, row.original]);
        }
      }}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: getRowBackgroundColor(row.original.leadStatus),
          cursor: onRowClick ? "pointer" : "default", // Indicate clickable rows
        },
        onClick: () => {
          if (onRowClick) {
            onRowClick(row);
          }
        },
      })}
      renderTopToolbarCustomActions={({ table }) => {
        const selected = table
          .getSelectedRowModel()
          .flatRows.map((item) => item.original);

        return enableActionButton ? (
          <TextField
            select
            variant="outlined"
            size="small"
            sx={{ minWidth: "200px" }}
            label="Action"
            value=""
            onChange={(e) => onChangeAction(e, selected)}
          >
            {actionText.map((status) => (
              <MenuItem key={status.id} value={status.id}>
                {status.label}
              </MenuItem>
            ))}
          </TextField>
        ) : null;
      }}
    />
  );
};
